export const workoutsKeywords = {
  newWorkout: 'new-workout',
};
